// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupDetailsCard_container__1yvgB","iconStyle":"GroupDetailsCard_iconStyle___Nqd9"};